import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let messages = {}
messages['nl'] = getMessages('nl')

export const i18n = new VueI18n({
    locale: 'nl',
    fallbackLocale: 'nl',
    messages
});

function getMessages(lang) {
    let requireModule = null
    if (lang === 'nl') requireModule = require.context('@localization/nl/.', false, /\.json$/)

    let messages = {}
    messages[lang] = {}
    requireModule.keys().forEach(fileName => {
        const key = fileName.replace(/(\.\/|\.json)/g, '')
        messages[lang][key] = requireModule(fileName)
    });

    return messages[lang];
}